// tslint:disable:max-line-length

import React from 'react';

export const LogoTwitter = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M11.063 0c-1.813 0-3.281 1.469-3.281 3.281 0 .257.038.51.094.75-2.728-.137-5.131-1.451-6.75-3.438-.282.485-.469 1.055-.469 1.656 0 1.139.588 2.13 1.469 2.719-.538-.017-1.026-.16-1.469-.406v.063c0 1.59 1.123 2.918 2.625 3.219-.276.075-.576.094-.875.094-.212 0-.425-.024-.625-.063.418 1.304 1.657 2.254 3.094 2.281-1.124.88-2.556 1.406-4.094 1.406-.265 0-.524-.001-.781-.031 1.453.931 3.177 1.469 5.031 1.469 6.038 0 9.344-5.007 9.344-9.344 0-.143.006-.265 0-.406.641-.463 1.185-1.061 1.625-1.719-.588.261-1.211.452-1.875.531.677-.407 1.193-1.046 1.438-1.813-.634.376-1.346.634-2.094.781-.599-.637-1.462-1.031-2.406-1.031z" />
    </svg>
  );
};
